import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="footer-wrap">
      <div className="footer-inner">
        <div className="footer-main">
          <div>
            <p className="footer-title">About Us</p>
            <p className="footer-copy">
              Maxx Fibernet is a franchise of renowned Class A ISP World Phone
              Internet Services Pvt. Ltd., powered by World Phone.
            </p>
            <div className="footer-contact footer-contact-inline">
              <a href="tel:+919935136926">Farhat Tabassum</a>
              <a href="tel:+919935136926">+91 99351 36926</a>
              <span aria-hidden="true">•</span>
              <a href="mailto:sj135637@gmail.com">sj135637@gmail.com</a>
            </div>
          </div>

          <div>
            <p className="footer-title">Useful Links</p>
            <nav className="footer-links" aria-label="Useful links">
              <Link to="/terms">Terms &amp; Conditions</Link>
              <Link to="/privacy">Privacy Policy</Link>
              <Link to="/terms">Cancellation Policy</Link>
              <Link to="/refund-policy">Online Refund Policy</Link>
            </nav>
          </div>

        </div>

        <div className="footer-bottom-row">
          <span>© {new Date().getFullYear()} Maxx Fibernet</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
